import axios from '@/core/axios';

export interface AccessoryRef {
  id: number;
  code: string;
  desc: string;
  product_type?: string | null;
  quantity?: number | null;
}

export interface ChargerRef {
  id: number;
  code: string;
  desc: string;
  quantity?: number | null;
}

export interface AccessoryRefOptions {
  product_type: string[];
}

class AccessoriesRefsService {
  listAccessoryRefs(
    params: { fulltext?: string; product_type?: string[] } = {}
  ): Promise<{ values: AccessoryRef[]; count: number }> {
    return axios.get('/accessory-refs', { params }).then(resp => resp?.data);
  }

  getAccessoryRefOptions(): Promise<AccessoryRefOptions> {
    return axios.get('/accessory-refs/options').then(resp => resp?.data);
  }

  listChargerRefs(params: { fulltext?: string } = {}): Promise<{ values: ChargerRef[]; count: number }> {
    return axios.get('/charger-refs', { params }).then(resp => resp?.data);
  }
}

export const accessoriesRefsService = new AccessoriesRefsService();
